import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserSleepsService } from 'src/app/services/user-sleeps.service';

@Component({
  selector: 'app-weekly-report-chart-sleep',
  templateUrl: './weekly-report-chart-sleep.component.html',
  styleUrls: ['./weekly-report-chart-sleep.component.scss']
})
export class WeeklyReportChartSleepComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Quality of sleep',
        fill: false,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#01E5BE',
      },
      {
        data: [  ],
        label: 'Getting to sleep',
        fill: false,
        tension: 0.5,
        borderColor: '#EF9742',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#EF9742',
        pointBorderColor:'#EF9742',
      },
      {
        data: [  ],
        label: 'Awakening from sleep in the night',
        fill: false,
        tension: 0.5,
        borderColor: '#E54B38',
        borderWidth:2,
        backgroundColor: 'rgba(0,0,0,0)',
        pointBackgroundColor:'#E54B38',
        pointBorderColor:'#E54B38',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 10,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "SCORE",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = true;


  constructor(private userSleepService: UserSleepsService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.datasets[1].data = [];
    this.lineChartData.datasets[2].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.lineChartData.labels?.push(
        weekNo+1
      );


      var weekTotals = this.userSleepService.getWeekScore(weekData);

      var quality = 0;
      var getting_sleep = 0;
      var awakening = 0;
      if(weekTotals.totalDays > 0) {
        quality = Math.round(weekTotals.quality / weekTotals.totalDays);
        getting_sleep = Math.round(weekTotals.getting_sleep / weekTotals.totalDays);
        awakening = Math.round(weekTotals.awakening / weekTotals.totalDays);
      }


      this.lineChartData.datasets[0].data.push(quality);
      this.lineChartData.datasets[1].data.push(getting_sleep);
      this.lineChartData.datasets[2].data.push(awakening);
    });
  }


}
